export default {
  // apiHost: 'http://47.101.39.148',
  apiHost: 'https://shiyuanan.com',
  // mapKey: '2275f97cfc594371acad0f97d53090d9'
  mapKey: '62289501d9c200fe4d3a8d315097ac54'
}
